import type { ReactElement } from 'react';

import BpkLargeAiIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/ai';
import BpkIconCarsLarge from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/cars';
import BpkIconHotelsLarge from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/hotels';
import BpkIconWorldLarge from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/world--amer';
import { BpkVessel } from '@skyscanner-internal/backpack-web/bpk-component-layout';
import classNames from 'classnames';

import { NAV_CARD_TYPES } from '../../hardcodedNavigationFallbackCards';

import STYLES from './CardIcon.module.scss';

type OwnProps = {
  type: string;
};

export const CardIcon = ({ type }: OwnProps): ReactElement => {
  switch (type) {
    case NAV_CARD_TYPES.EXPLORE_AI:
      return (
        <BpkVessel className={classNames([STYLES.iconWrapper, STYLES.logoImageRedesign])}>
          <BpkLargeAiIcon className={STYLES.iconFill} />
        </BpkVessel>
      );
    case NAV_CARD_TYPES.HOTELS:
      return (
        <BpkVessel className={classNames([STYLES.iconWrapper, STYLES.logoImageRedesign])}>
          <BpkIconHotelsLarge className={STYLES.iconFill} />
        </BpkVessel>
      );

    case NAV_CARD_TYPES.CAR_HIRE:
      return (
        <BpkVessel className={classNames([STYLES.iconWrapper, STYLES.logoImageRedesign])}>
          <BpkIconCarsLarge className={STYLES.iconFill} />
        </BpkVessel>
      );

    case NAV_CARD_TYPES.EXPLORE_EVERYWHERE:
    default:
      return (
        <BpkVessel className={classNames([STYLES.iconWrapper, STYLES.logoImageRedesign])}>
          <BpkIconWorldLarge className={STYLES.iconFill} />
        </BpkVessel>
      );
  }
};
